// bao migrate skip
import EvaluationViewModel from "./../../checkware/view-models/evaluation-view-model";
import * as $ from "jquery";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import baoShouter from "./../../services/bao-shouter";
/**
 * ViewModel for the Shiftbook's Evaluation-Tab
 */
class ShiftReportCheckwareTab extends (EvaluationViewModel as any) {
    ToolbarButtons = ko.observableArray<Interfaces.Bao.BaoMenuItem>([]);
    ShiftReport: {
        ReportId: KnockoutObservable<string>;
        ShiftbookId: KnockoutObservable<string>;
    };
    CalculateWidth() {
        //Dummy
    }
    ;
    BaoRouterSubscriptions = [];
    Bao = Bao;
    TabName = ko.observable();
    /** Evaluation UrlData
    */
    UrlData = ko.observable();
    /** Evaluation URL
     */
    Url = ko.observable("Checkware/Evaluation/Open");
    IsHistory = ko.observable(false);
    Permissions: KnockoutObservableArray<any> = ko.observableArray([]);
    ShiftbookTabId: KnockoutObservable<any>;
    SaveAllowed = ko.observable(true); //TODO: wird aus C# Model noch befüllt (HasPermission)
    ToggleButtons = () => {
        ko.utils.arrayForEach(this.ToolbarButtons(), (button: any) => {
            if (button.ActionKey() == "ShiftReportTabEvaluationSave" || button.ActionKey() == "ShiftReportTabEvaluationClose") {
                button.Enabled(this.ChecklistModel && this.ChecklistModel.CompleteDate && this.ChecklistModel.CompleteDate() == null);
            }
        });
    };
    constructor(tabPage, shiftReportViewModel) {
        super(tabPage);
        this.UrlData({ evaluationId: null })
        this.ShiftbookTabId = ko.observable(tabPage.ObjectId());
        tabPage.TabSelected = () => {
            this.CalculateWidth();
        };
        this.ShiftReport = shiftReportViewModel;
        this.Subscribe(this.ToolbarButtons, () => {
            this.ToggleButtons();
            this.SetVisibilityButtons();
        });
        this.Permissions.subscribe(_ => {
            this.SetVisibilityButtons();
        });
    }
    private _subscriptions: KnockoutSubscription[] = [];
    Subscribe<T>(obs: KnockoutObservable<T>, fn: (newValue?: T) => void) {
        this._subscriptions.push(obs.subscribe(fn));
    }
    CompleteCheck(closeReport): JQueryPromise<boolean>  {
        if (closeReport == true && !this.IsCompleted()) {
            //TODO: evtl. Checklisten Logik aufrufen?
            return Bao.post("CheckwareTab/CompleteCheckForReportClose", JSON.stringify({
                reportId: this.ShiftReport.ReportId(),
                shiftbookTabId: this.ShiftbookTabId()
            })).then((res: {
                Message: string,
                Result: boolean;
            }) => {                
                return res && res.Result;
            })
        }
        return $.Deferred<boolean>().resolve(true).promise();
    }
    ;
    canClose() {
        var def = $.Deferred();
        if (this.IsHistory()) {
            def.resolve(true); //TODO: History einbauen / überprüfen
        }
        else {
            if (this.TabPage.DirtyFlag() && this.SaveAllowed()) {
                def.resolve(false);
            }
            else {
                def.resolve(true);
            }
        }
        return def.promise();
    }
    ;
    ToolbarLoaded = () => {
        //dummy
    };
    CloseReport() {
        var def = $.Deferred();
        if (this.IsCompleted()) {
            def.resolve(true);
        }
        else {
            //Checkliste abschließen
            this.JsManager.CompleteChecklistDone = (success) => {
                def.resolve(success);
                this.ToggleButtons();
            };
            if (this.ChecklistModel) {
                this.ChecklistModel.Complete();
            }
        }
        return def.promise();
    }
    ;
    ToolbarClick = (action) => {
        switch (action.ActionKey()) {
            case "ShiftReportTabEvaluationSave":
                this.Save();
                break;
            case "ShiftReportTabEvaluationExportPdf":
                this.ExportPdf();
                break;
            case "ShiftReportTabEvaluationClose":
                this.CloseReport();
                break;
        }
    };

    BaseEvaluationLoaded = (this as any).EvaluationLoaded;
    EvaluationLoaded = () => {
        this.ToggleButtons();
        this.SetVisibilityButtons();
        if (this.ListName()){
            this.TabPage.Title(this.ListName()) 
        }
        // super.BaseEvaluationLoaded();
        this.BaseEvaluationLoaded();
    };
    // BaseInit = this.init;
    init = () => {       
        return this.LoadEvaluationId()
            .then(() => this.LoadPermissions())
    };

    /**
     * Method to load an EvaluationId
     */
    protected LoadEvaluationId() {
        return Bao.post("CheckwareTab/GetEvaluationIdByShiftbookTabId", JSON.stringify({            
            reportId: this.ShiftReport.ReportId(),
            shiftbookTabId: this.ShiftbookTabId()
        }))
        .then((res: {
            EvaluationId: string;
        }) => {
            if (res && res.EvaluationId) {
                this.EvaluationId(res.EvaluationId);
                this.UrlData({ evaluationId: this.EvaluationId() });
            }
            else {
                this.UrlData({ evaluationId: null })
            }
        })
    }

    dispose() {
        for (var y = 0; y < this._subscriptions.length; y++) {
            this._subscriptions[y].dispose();
        }
        this._subscriptions = null;
    }

    private LoadPermissions() {
        return Bao.post("RoleShiftbookTab/GetPermissions", JSON.stringify({ shiftbookId: this.ShiftReport.ShiftbookId(), shiftbookTabId: this.ShiftbookTabId() }))
            .then((result) => this.Permissions(result.Permissions));
    }

    private SetVisibilityButtons() {
        this.ToolbarButtons().forEach((btn) => {
            const actionKey = ko.unwrap(btn.ActionKey);
            let permission = this.Permissions()[actionKey];
            if (permission === null || permission === undefined)
                permission = false;
            btn.Visible = permission;
        });
    }
}
export default ShiftReportCheckwareTab;